import React, { forwardRef } from 'react';
import styled from 'styled-components';
import Typography from '../Typography';
import type { ButtonProps } from './index.d';
import { Btn, BtnWrapper, IconWrapper, LoadingWrapper, ButtonText, LoadingButtonIcon } from './view';

const Button: React.ComponentType<ButtonProps & React.RefAttributes<HTMLButtonElement>> = forwardRef<
    HTMLButtonElement,
    ButtonProps
>((props, ref) => {
    const {
        children,
        className,
        disabled = false,
        keepStylesWhenDisabled = false,
        focusVisibleClassName,
        fullWidth = false,
        type,
        variant = 'primary',
        color,
        textVariant = 'button',
        placement,
        icon = null,
        withIconBg,
        loading,
        cy,
        size,
        buttonType,
        tabIndex,
        autoFocus,
        ...other
    } = props;

    const buttonComponent = (
        <Btn
            ref={ref}
            className={className}
            disabled={disabled}
            $keepStylesWhenDisabled={keepStylesWhenDisabled}
            type={type}
            data-cy={cy}
            $variant={variant}
            $fullWidth={fullWidth}
            $color={color}
            $size={size}
            $buttonType={buttonType}
            tabIndex={tabIndex}
            data-autofocus={autoFocus}
            {...other}
        >
            {icon && !loading && withIconBg && <IconWrapper>{icon}</IconWrapper>}
            {icon && !loading && !withIconBg && icon}
            {loading && (
                <LoadingWrapper>
                    <LoadingButtonIcon
                        icon="icSpinner"
                        size={16}
                        colorVariant="third"
                    />
                </LoadingWrapper>
            )}
            <ButtonText $isVisible={!!(children && !loading)}>
                <Typography
                    variant={textVariant}
                    color="inherit"
                    margin={icon ? '0 0 0 8px' : ''}
                >
                    {children}
                </Typography>
            </ButtonText>
        </Btn>
    );

    return placement ? (
        <BtnWrapper
            className={className}
            placement={placement}
        >
            {buttonComponent}
        </BtnWrapper>
    ) : (
        buttonComponent
    );
});

export default styled(Button)``;
